/**
 * Consent gates for third-party scripts controlled by Shopify Customer Privacy.
 *
 * 1) Judge.me — blocks only requests to tracking.aws.judge.me (e.g. track_bulk_events)
 *    until Shopify Customer Privacy reports analytics consent. Other Judge.me
 *    hosts (cdn.judge.me, api.judge.me, widget assets) are untouched.
 *
 * 2) Impact Radius — UTT must be loaded from the theme (see theme settings) after
 *    marketing consent; the Impact "UTT" app embed should be disabled to avoid double load.
 *
 * 3) Microsoft Clarity — loaded after analytics consent when Liquid passes a project
 *    ID (US showcase only).
 *
 * Runs synchronously before content_for_header so patches apply before app scripts.
 */
(function () {
  var JUDGE_TRACKING_HOST = 'tracking.aws.judge.me';

  var cfg = {};
  try {
    var el = document.getElementById('sk-consent-third-party-config');
    if (el && el.textContent) cfg = JSON.parse(el.textContent);
  } catch (e) {}

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      if (typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() === true;
      }
      // Backward compatibility for older Customer Privacy API builds.
      if (typeof cp.analyticsAllowed === 'function') {
        return cp.analyticsAllowed() === true;
      }
      return false;
    } catch (err) {
      return false;
    }
  }

  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return false;
      if (!cp.marketingAllowed()) return false;
      if (typeof cp.saleOfDataAllowed === 'function' && !cp.saleOfDataAllowed()) return false;
      return true;
    } catch (err2) {
      return false;
    }
  }

  function emptyJsonResponse() {
    return new Response('{}', {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  /* --- Judge.me analytics / impression host only --- */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var u = typeof input === 'string' ? input : input && input.url;
      u = u || '';
      if (u.indexOf(JUDGE_TRACKING_HOST) !== -1 && !analyticsAllowed()) {
        return Promise.resolve(emptyJsonResponse());
      }
      return origFetch.apply(this, arguments);
    };
  }

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__skUrl = typeof url === 'string' ? url : '';
    this.__skMethod = method;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var u = this.__skUrl || '';
    if (u.indexOf(JUDGE_TRACKING_HOST) !== -1 && !analyticsAllowed()) {
      xhrOpen.call(this, 'GET', 'data:application/json,' + encodeURIComponent('{}'), true);
      return xhrSend.call(this);
    }
    return xhrSend.apply(this, arguments);
  };

  var origBeacon = navigator.sendBeacon && navigator.sendBeacon.bind(navigator);
  if (typeof origBeacon === 'function') {
    navigator.sendBeacon = function (url, data) {
      if (typeof url === 'string' && url.indexOf(JUDGE_TRACKING_HOST) !== -1 && !analyticsAllowed()) {
        return true;
      }
      return origBeacon(url, data);
    };
  }

  /* --- Impact UTT (utt.impactcdn.com) — fail closed until Customer Privacy exists --- */
  var impactLoaded = false;
  function impactFilename() {
    var fn = cfg && cfg.impactUtt;
    if (!fn || typeof fn !== 'string') return '';
    fn = fn.trim();
    if (!/^[\w.-]+\.js$/i.test(fn)) return '';
    return fn;
  }

  function loadImpactUtt() {
    if (impactLoaded) return;
    var fn = impactFilename();
    if (!fn) return;
    if (!marketingAllowed()) return;
    impactLoaded = true;
    var s = document.createElement('script');
    s.src = 'https://utt.impactcdn.com/' + fn;
    s.async = true;
    document.head.appendChild(s);
  }

  function onVisitorConsentCollected() {
    loadImpactUtt();
    loadClarity();
  }

  document.addEventListener('visitorConsentCollected', onVisitorConsentCollected);

  /* --- Microsoft Clarity — fail closed until analytics consent; US-only via Liquid config --- */
  var clarityLoaded = false;
  function clarityProjectId() {
    var id = cfg && cfg.clarityProjectId;
    if (!id || typeof id !== 'string') return '';
    id = id.trim();
    if (!/^[a-z0-9]+$/i.test(id)) return '';
    return id;
  }

  function loadClarity() {
    if (clarityLoaded) return;
    var id = clarityProjectId();
    if (!id) return;
    if (!analyticsAllowed()) return;
    clarityLoaded = true;
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i + '?ref=bwt';
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', id);
  }

  var tries = 0;
  function waitCustomerPrivacy() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.marketingAllowed === 'function') {
      if (marketingAllowed()) loadImpactUtt();
      if (analyticsAllowed()) loadClarity();
      return;
    }
    if (++tries < 400) {
      setTimeout(waitCustomerPrivacy, 50);
    }
  }

  waitCustomerPrivacy();
})();
